import { api, ApiError } from '@/lib/api';
import type { GroomReport, UpsertGroomReportInput } from './types';

/** The session's report, or null if the groomer hasn't started one yet (404). */
export async function fetch_groom_report(booking_id: string): Promise<GroomReport | null> {
  try {
    const res = await api.get<GroomReport>(`/vendor/bookings/${booking_id}/groom-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

export async function save_groom_report(
  booking_id: string,
  input: UpsertGroomReportInput,
): Promise<GroomReport> {
  const res = await api.put<GroomReport>(`/vendor/bookings/${booking_id}/groom-report`, input);
  return res.data;
}

export async function publish_groom_report(booking_id: string): Promise<GroomReport> {
  const res = await api.post<GroomReport>(`/vendor/bookings/${booking_id}/groom-report/publish`);
  return res.data;
}

/** Owner side: the PUBLISHED report for a booking, or null (DRAFTs 404 → null). */
export async function fetch_owner_groom_report(booking_id: string): Promise<GroomReport | null> {
  try {
    const res = await api.get<GroomReport>(`/user/bookings/${booking_id}/groom-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
